import React, { Component } from 'react';

import moment from 'moment';
import { connect } from 'react-redux';
import { closeBanner, openBanner } from '../actions';
import { Link } from 'react-router-dom';

class NewFeatureNotification extends Component {
  constructor(props) {
    super(props);
    this.checkBanner();
  }

  get hasNotification() {
    const { title, message, expiry } = this.props.new_feature_banner;
    if (!title || !message || !expiry) return false;
    const expiry_date = moment(expiry, 'MM/DD/YYYY hh:mm A');
    return moment().isBefore(expiry_date);
  }

  checkBanner() {
    if (!this.hasNotification || this.props.new_feature_banner.dismissed) return false;
    this.props.openBanner();
    return true;
  }

  featureLink() {
    return process.env.REACT_APP_FEATURE_LINK || '/'
  }

  render() {
    const { title, message, open } = this.props.new_feature_banner;
    if (!open) return null;

    return (
      <div className='ds-banner -warning'>
        <h1>{title}</h1>
        <p className='copy emphasize -base' data-test='notification-body'>
          Click{" "}
          <Link to={{pathname: this.featureLink()}}>
            here{" "}
          </Link>
          {message}
        </p>
        <a
          className='dismiss'
          role='button'
          onClick={this.props.closeBanner}
          data-testid='new-feature-dismiss'
        >
          <i className='materialIcon --micro -base'> close </i>
        </a>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    new_feature_banner: state.shared.ui.new_feature_banner,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    closeBanner: () => dispatch(closeBanner("new_feature_banner")),
    openBanner: () => dispatch(openBanner("new_feature_banner")),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewFeatureNotification);


// WEBPACK FOOTER //
// ./src/features/shared/containers/NewFeatureNotification.js